import { InjectionToken } from '@angular/core';
import type { TranscriptionConfig } from './transcription.interface';

export const TRANSCRIPTION_CONFIG = new InjectionToken<TranscriptionConfig>(
  'TranscriptionConfig',
);
